export default "/fonts/icomoon.ttf?f95f06b9b6cdf719c22c1cb167a07631";